import angular from 'angular';
import uiRouter from 'angular-ui-router';
import banktxBulkComponent from './banktx-bulk.component';

let banktxBulkModule = angular.module('banktxBulk', [
    uiRouter
])
.config(($stateProvider) => {
    'ngInject';
    $stateProvider
        .state('banktxBulk', {
            url: '/banktxBulk',
            component: 'banktxBulk',
            parent: 'main',
            data: {
                permissions: {
                    only: ['ADMIN'],
                    redirectTo: 'home'
                }
            }
        });

})
.component('banktxBulk', banktxBulkComponent)
.name;

export default banktxBulkModule;
